module.exports = __webpack_public_path__ + "static/media/tuf_logo.8cf565ab.svg";